import React from 'react';
import './visiting info.css'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBModal, MDBModalBody, MDBModalHeader } from "mdbreact";
import "react-image-gallery/styles/css/image-gallery.css";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import allStrings from "../../assets/strings";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { BASE_END_POINT } from "../../urls";
import axios from "axios";
import { message, Spin, DatePicker, TreeSelect, Button } from "antd";
import { hasValue } from "../../validations/validations";
import moment from "moment"
import { ArrowRightOutlined } from "@ant-design/icons";

const { TreeNode } = TreeSelect
class visitingInfo extends React.Component {
  state = {
    actionType: this.props.location.state.actionType ? this.props.location.state.actionType === "EDIT" ? "EDIT" : "VIEW" : "VIEW",
    page: 1,
    pages: 1,
    id: this.props.location.state.data.id ? this.props.location.state.data.id : null,
    status: this.props.location.state.data.status ? this.props.location.state.data.status : "",
    type: this.props.location.state.data.type ? this.props.location.state.data.type : "",
    fullname: this.props.location.state.data.fullname ? this.props.location.state.data.fullname : "",
    phone: this.props.location.state.data.phone ? this.props.location.state.data.phone : "",
    project: this.props.location.state.data.project ? this.props.location.state.data.project.id : "",
    report: this.props.location.state.data.report ? this.props.location.state.data.report : "",
    employee: this.props.location.state.data.employee ? this.props.location.state.data.employee : null,
    visitingDate: null,
    loading: false,
    requestType: 'COMPLETED',
    projects: [],
    priceFrom: 0,
    priceTo: 0,
    cities: [],
    areas: [],
    categories: [],
    subCategories: [],
    city: null,
    area: null,
    direction: null,
    category: null,
    subCategory: null,
    modalForCreateRequest: false,
    visitingsSearchData: null,
    bedrooms: null

  };

  constructor(props) {
    super(props)
    window.scrollTo(0, 0)
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }
  componentDidMount() {
    if (sessionStorage.getItem('visitingsSearchData')) {
      let visitingsSearchData = sessionStorage.getItem('visitingsSearchData');
      if (visitingsSearchData != '{}') this.setState({ visitingsSearchData: visitingsSearchData })
    }
    this.getData()
    this.getProjects()
    this.getCategory()
    this.getCities(1)
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }
  getData = () => {
    axios.get(`${BASE_END_POINT}visitings/${this.state.id}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en'
      }
    })
      .then(response => {
        console.log('visit  ', response.data)
        this.setState({
          id: response.data.data.id,
          status: response.data.data.status,
          type: response.data.data.type,
          fullname: response.data.data.fullname,
          phone: response.data.data.phone,
          project: response.data.data.project ? response.data.data.project.id : "",
          report: response.data.data.report ? response.data.data.report : "",
          employee: response.data.data.employee ? response.data.data.employee : null,
          visitingDate: response.data.data.visitingDate ? response.data.data.visitingDate : null,
          loading: false,
        })
      })
      .catch(error => {
        console.log('interest ERROR  ', error)
        console.log('interest ERROR  ', error.respose)
      })
  }
  getCountry = (id) => {
    axios.get(`${BASE_END_POINT}countries/${id}`)
      .then(response => {
        console.log("country", response.data.data)
        this.setState({
          phone: this.state.phone.replace(response.data.data.countryCode, "")
        })
      })
      .catch(error => {
        console.log(" country ERROR")
        console.log(error.response)
      })
  }
  getCities = (country) => {
    axios.get(`${BASE_END_POINT}countries/1/cities/withoutPagenation/get?country=${country}`)
      .then(response => {
        console.log('cities  ', response.data)
        this.setState({ cities: response.data.data })
      })
      .catch(error => {
        console.log('cities ERROR  ', error)
        console.log('cities ERROR  ', error.respose)
      })
  }
  getAreas = (city) => {
    axios.get(`${BASE_END_POINT}areas/${city}/withoutPagenation/get`)
      .then(response => {
        console.log(response.data)
        this.setState({ areas: response.data.data })
      })
      .catch(error => {
        console.log("ALL areas ERROR")
        console.log(error.response)
      })
  }
  getCategory = () => {
    axios.get(`${BASE_END_POINT}categories`)
      .then(response => {
        console.log(response.data)
        this.setState({ categories: response.data.data })
      })
      .catch(error => {
        console.log("ALL categories ERROR")
        console.log(error.response)
      })
  }
  getSubCategory = (category) => {
    axios.get(`${BASE_END_POINT}categories/${category}/sub-categories`)
      .then(response => {
        console.log(response.data)
        this.setState({ subCategories: response.data.data })
      })
      .catch(error => {
        console.log("ALL subCategories ERROR")
        console.log(error.response)
      })
  }
  getProjects = () => {
    axios.get(`${BASE_END_POINT}projects/withoutPagenation/get`)
      .then(response => {
        console.log(response.data)
        this.setState({ projects: response.data.data })
      })
      .catch(error => {
        console.log("ALL projects ERROR")
        console.log(error.response)
      })
  }
  delete = () => {
    let l = message.loading('Wait..', 2.5)
    axios.delete(`${BASE_END_POINT}visitings/${this.props.location.state.data.id}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en'
      },
    })
      .then(response => {
        console.log("visit DELETED")
        l.then(() => message.success(allStrings.done, 2.5))
        this.props.history.goBack()
      })
      .catch(error => {
        console.log(error.response)
        l.then(() => message.error(allStrings.error, 2.5))
      })
  }
  update = () => {
    const { fullname, phone, project, status, report, visitingDate } = this.state
    if (hasValue(fullname) && hasValue(phone) && project != null, visitingDate != null) {
      let l = message.loading('Wait..', 2.5)
      let data = {
        fullname: fullname,
        phone: phone,
        project: project,
        status: status,
        visitingDate: visitingDate,
        report: report,
      }
      axios.put(`${BASE_END_POINT}visitings/${this.state.id}`, data, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.props.currentUser.token}`,
          'Accept-Language': this.props.isRTL ? 'ar' : 'en'
        },
      })
        .then(response => {
          console.log("visiting UPDATED  ", response.data)
          l.then(() => message.success(allStrings.done, 2.5))
          this.props.history.goBack()
        })
        .catch(error => {
          console.log(error.response)
          l.then(() => message.error(error.response.data.errors[0].msg, 2.5))
        })
    }
  }
  changeHandler = event => {
    this.setState({ [event.target.name]: event.target.value });
  };
  submitHandler = (event) => {
    event.preventDefault();
    event.target.className += " was-validated";
    this.update()
  };
  createRequest = () => {
    const { priceFrom, priceTo, city, area, direction, category, subCategory, bedrooms } = this.state

    if (city != null && area != null && category != null && subCategory != null && direction != null) {
      let l = message.loading('Wait..', 2.5)
      let data = {
        priceFrom: priceFrom,
        priceTo: priceTo,
        city: city,
        area: area,
        direction: direction,
        category: category,
        subCategory: subCategory,
      }
      if (bedrooms) data.bedrooms = bedrooms
      axios.post(`${BASE_END_POINT}visitings/${this.props.location.state.data.id}/createClientRequest`, data, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.props.currentUser.token}`,
          'Accept-Language': this.props.isRTL ? 'ar' : 'en',
        },
      })
        .then(response => {
          console.log("createClientRequest done")
          l.then(() => message.success(allStrings.done, 2.5))
          this.props.history.goBack()
        })
        .catch(error => {
          console.log(error.response)
          l.then(() => message.error(allStrings.error, 2.5))
        })
    }
  }
  submitHandlerCreateRequest = (event) => {
    event.preventDefault();
    event.target.className += " was-validated";
    this.createRequest()
  };
  toggleForCreateRequest = (modalType) => {
    this.setState({
      modalForCreateRequest: !this.state.modalForCreateRequest,
    });
  }
  modalForCreateRequest = () => (
    <MDBModal isOpen={this.state.modalForCreateRequest} toggle={this.toggleForCreateRequest} size="lg">
      <MDBModalHeader toggle={this.toggleForCreateRequest} >{allStrings.completeData}</MDBModalHeader>
      <MDBModalBody>
        <MDBContainer>
          <MDBRow>
            <MDBCol md="12">
              <form style={{ paddingTop: '1rem' }}
                className="needs-validation"
                onSubmit={this.submitHandlerCreateRequest}
                noValidate
              >
                <div className="grey-text">
                  <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                    <MDBCol md="6">
                      <div className="md-form">
                        <label htmlFor="form920" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}><span style={{ color: '#ef4444' }}>*</span> {allStrings.priceFrom}</label>
                        <input name="priceFrom" onChange={this.changeHandler} style={{ border: 'none', borderBottom: '1px solid #dededede', direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} type="number" min={0} id="form920" className="form-control" validate required placeholder="السعر من..." />
                        <div class="valid-feedback">{allStrings.correct}</div>
                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                      </div>
                    </MDBCol>
                    <MDBCol md="6">
                      <div className="md-form">
                        <label htmlFor="form920" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}><span style={{ color: '#ef4444' }}>*</span> {allStrings.priceTo}</label>
                        <input name="priceTo" onChange={this.changeHandler} style={{ border: 'none', borderBottom: '1px solid #dededede', direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} type="number" min={0} id="form920" className="form-control" validate required placeholder="السعر إلى..." />
                        <div class="valid-feedback">{allStrings.correct}</div>
                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                      </div>
                    </MDBCol>
                  </MDBRow>
                  <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                    <MDBCol md="6">
                      <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}><span style={{ color: '#ef4444' }}>*</span> {allStrings.category}</label>
                      <TreeSelect virtual={false}
                        showSearch={true}
                        style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                        treeCheckable={false}
                        treeNodeFilterProp="title"
                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                        placeholder={allStrings.category}
                        onChange={(value) => {
                          console.log(value)
                          this.setState({ category: value });
                          this.getSubCategory(value)
                        }}

                      >
                        {this.state.categories.map(val => (
                          <TreeNode value={val.id} title={this.props.isRTL ? val.categoryName_ar : val.categoryName_en} key={val.id} />
                        ))}
                      </TreeSelect>
                    </MDBCol>
                    <MDBCol md="6">
                      <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}><span style={{ color: '#ef4444' }}>*</span> {allStrings.subCategory}</label>
                      <TreeSelect virtual={false}
                        showSearch={true}
                        style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                        treeCheckable={false}
                        treeNodeFilterProp="title"
                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                        placeholder={allStrings.subCategory}
                        onChange={(value) => {
                          console.log(value)
                          this.setState({ subCategory: value });
                        }}

                      >
                        {this.state.subCategories.map(val => (
                          <TreeNode value={val.id} title={this.props.isRTL ? val.categoryName_ar : val.categoryName_en} key={val.id} />
                        ))}
                      </TreeSelect>
                    </MDBCol>
                  </MDBRow>
                  <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                    <MDBCol md="6">
                      <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}><span style={{ color: '#ef4444' }}>*</span> {allStrings.city}</label>
                      <TreeSelect virtual={false}
                        showSearch={true}
                        style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                        treeCheckable={false}
                        treeNodeFilterProp="title"
                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                        placeholder={allStrings.city}
                        onChange={(value) => {
                          console.log(value)
                          this.setState({ city: value });
                          this.getAreas(value)
                        }}

                      >
                        {this.state.cities.map(val => (
                          <TreeNode value={val.id} title={this.props.isRTL == "ar" ? val.cityName_ar : val.cityName_en} key={val.id} />
                        ))}
                      </TreeSelect>
                    </MDBCol>
                    <MDBCol xl="6">
                      <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}><span style={{ color: '#ef4444' }}>*</span> {allStrings.area}</label>
                      <TreeSelect virtual={false}
                        showSearch={true}
                        style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                        treeCheckable={false}
                        treeNodeFilterProp="title"
                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                        placeholder={allStrings.area}
                        onChange={(value) => {
                          console.log(value)
                          this.setState({ area: value });
                        }}

                      >
                        {this.state.areas.map(val => (
                          <TreeNode value={val.id} title={this.props.isRTL ? val.areaName_ar : val.areaName_en} key={val.id} />
                        ))}
                      </TreeSelect>
                    </MDBCol>
                  </MDBRow>
                  <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                    <MDBCol md="6">
                      <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.direction}</label>
                      <TreeSelect virtual={false}
                        showSearch={true}
                        style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                        treeCheckable={false}
                        treeNodeFilterProp="title"
                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                        placeholder={allStrings.direction}
                        onChange={(value) => {
                          console.log(value)
                          this.setState({ direction: value });
                        }}

                      >
                        <TreeNode value="EAST" title={allStrings.east} key="EAST" />
                        <TreeNode value="WEST" title={allStrings.west} key="WEST" />
                        <TreeNode value="NORTH" title={allStrings.north} key="NORTH" />
                        <TreeNode value="SOUTH" title={allStrings.south} key="SOUTH" />
                        <TreeNode value="CENTER" title={allStrings.center} key="CENTER" />

                      </TreeSelect>
                    </MDBCol>
                    <MDBCol md="6">
                      <div className="md-form">
                        <label htmlFor="form920" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.bedrooms}</label>
                        <input name="bedrooms" onChange={this.changeHandler} style={{ border: 'none', borderBottom: '1px solid #dededede', direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} type="number" min={1} id="form920" className="form-control" validate required placeholder="عدد الغرف..." />
                        <div class="valid-feedback">{allStrings.correct}</div>
                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                      </div>
                    </MDBCol>
                  </MDBRow>
                </div>
                <div className="drawer-action-footer">
                  <MDBBtn type="button" className="btn-cancel" onClick={this.toggleForCreateRequest}>
                    إلغاء
                  </MDBBtn>
                  <MDBBtn type="submit" className="btn-submit">
                    {allStrings.send}
                  </MDBBtn>
                </div>
              </form>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </MDBModalBody>
    </MDBModal>
  );
  render() {
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('VISITINGS')) return <Redirect to='/Home' />
    return (
      <div className="App">
        <Spin spinning={this.state.loading} tip={allStrings.loading} size="large" style={{ color: '#1D9598' }}>
          <MDBContainer>
            {this.modalForCreateRequest()}
            {this.state.actionType == "VIEW" &&
              <MDBRow>
                <MDBCol md='12'>
                  <MDBBtn onClick={() => { this.delete() }} rounded style={{ display: 'inline-block', width: 'fit-content', margin: '8px', background: 'linear-gradient(135deg, #FF3547, #B71C1C)', color: '#fff', borderRadius: '10px' }} color="FF3547" className="btn-block z-depth-1a">
                    <MDBIcon icon="trash-alt" className="mr-2" />
                    {allStrings.remove}
                  </MDBBtn>
                  <MDBBtn rounded color="none"
                    style={{ display: 'inline-block', width: 'fit-content', margin: '8px', padding: '10px', background: '#fff', color: '#127275', borderRadius: '10px', border: '1px solid #127275' }}
                    className="btn-block z-depth-1a"
                    onClick={() => { this.toggleForCreateRequest() }}
                  >
                    {allStrings.createRequest}
                  </MDBBtn>
                  <Button
                    dir={this.props.isRTL ? 'rtl' : 'ltr'}
                    onClick={() => { this.props.history.push("visitings", { visitingsSearchData: JSON.parse(this.state.visitingsSearchData) }) }}
                    icon={<ArrowRightOutlined />}
                    style={{
                      float: this.props.isRTL ? 'right' : 'left',
                      textAlign: this.props.isRTL ? 'right' : 'left',
                      background: "linear-gradient(90deg, #1D9598, #127275)", color: "white",
                      border: "none", borderRadius: "12px", fontWeight: "500", marginTop: '8px',
                      padding: "0 16px", height: "40px", transition: "all 0.5s ease-in-out"
                    }}
                    onMouseEnter={(e) => { e.currentTarget.style.background = "linear-gradient(90deg, #127275, #1D9598)" }}
                    onMouseLeave={(e) => { e.currentTarget.style.background = "linear-gradient(90deg, #1D9598, #127275)" }}
                  >
                    {allStrings.back}
                  </Button>
                </MDBCol>
              </MDBRow>
            }
            <MDBRow>
              <MDBCol xl={this.state.actionType === "VIEW" ? "12" : "12"} lg={this.state.actionType === "VIEW" ? "12" : "12"} md="12" sm="12">

                <div className="infoCard">
                  <Card className="editCard" style={{ overflow: 'visible', outline: 'none', marginBottom: '0px' }}>
                    <CardMedia
                      style={{ height: "0px" }}
                    />
                    <CardHeader></CardHeader>
                    <div style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row', display: 'flex' }}>
                      <div className="topIcon" style={{ background: 'linear-gradient(135deg, #1D9598, #127275)' }}>
                        <span class="material-icons" style={{ color: 'white', fontSize: 20 }}>assignment</span>
                      </div>
                      <div className="tableTitle" style={{ display: 'inline-block', marginTop: '-60px', marginLeft: '0', marginRight: '0' }}>
                        <p>{this.state.actionType === "VIEW" ? allStrings.info : allStrings.edit}</p>
                      </div>
                    </div>
                    <CardContent style={{ minHeight: "390px", outline: 'none' }}>
                      <MDBContainer>
                        <MDBRow>
                          <MDBCol md="12">
                            <form
                              className="needs-validation"
                              onSubmit={this.submitHandler}
                              noValidate
                            >
                              <div className="grey-text">
                                {this.state.actionType === "VIEW" &&
                                  <MDBRow>
                                    <MDBCol md="6">
                                      <div class="md-form">
                                        <label htmlFor="form635" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.type}</label>
                                        <input disabled={this.state.actionType === "VIEW" ? true : false} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.type == "DIRECT" ? allStrings.directVisit : allStrings.formInterestVisit} type="text" id="form635" class="form-control" placeholder="أدخل البيانات..." />
                                        <div class="valid-feedback">{allStrings.correct}</div>
                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                      </div>
                                    </MDBCol>
                                    <MDBCol md="6">
                                      <div class="md-form">
                                        <label htmlFor="form605" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>#</label>
                                        <input disabled={this.state.actionType === "VIEW" ? true : false} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.id} type="text" id="form605" class="form-control" placeholder="أدخل البيانات..." />
                                        <div class="valid-feedback">{allStrings.correct}</div>
                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                      </div>
                                    </MDBCol>
                                  </MDBRow>
                                }
                                <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                                  <MDBCol md="6">
                                    <div className="md-form">
                                      <label htmlFor="form65" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.fullname}</label>
                                      <input disabled={this.state.actionType === "VIEW" ? true : false} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.fullname} type="text" id="form645" name="fullname" className="form-control" required onChange={this.changeHandler} validate placeholder="أدخل الاسم الكامل..." />
                                      <div class="valid-feedback">{allStrings.correct}</div>
                                      <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                    </div>
                                  </MDBCol>
                                  <MDBCol md="6">
                                    <div className="md-form">
                                      <label htmlFor="form56" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.phone}</label>
                                      <input disabled={this.state.actionType === "VIEW" ? true : false} onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^0-9+]/g, '')} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.phone} type="text" id="form56" name="phone" className="form-control" required onChange={this.changeHandler} validate placeholder="أدخل رقم الهاتف..." />
                                      <div class="valid-feedback">{allStrings.correct}</div>
                                      <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                    </div>
                                  </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                  <MDBCol md="6">
                                    <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.status}</label>
                                    <TreeSelect virtual={false}
                                      showSearch={true}
                                      value={this.state.status}
                                      disabled={this.state.actionType === "VIEW" ? true : false}
                                      style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                      treeCheckable={false}
                                      treeNodeFilterProp="title"
                                      dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                      placeholder={allStrings.status}
                                      onChange={(value) => {
                                        console.log(value)
                                        this.setState({ status: value });
                                      }}

                                    >
                                      <TreeNode value="PENDING" title={allStrings.pending} key="PENDING" />
                                      <TreeNode value="RESCHEDULED" title={allStrings.rescheduled} key="RESCHEDULED" />
                                      <TreeNode value="DONE" title={allStrings.done} key="DONE" />
                                      <TreeNode value="DEAL" title={allStrings.purchased} key="DEAL" />
                                      <TreeNode value="CANCELED" title={allStrings.canceled} key="CANCELED" />

                                    </TreeSelect>
                                  </MDBCol>
                                  <MDBCol md="6">
                                    <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.project}</label>
                                    <TreeSelect virtual={false}
                                      showSearch={true}
                                      style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                      treeCheckable={false}
                                      disabled={this.state.actionType === "VIEW" ? true : false}
                                      treeNodeFilterProp="title"
                                      dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                      placeholder={allStrings.project}
                                      value={this.state.project}
                                      onChange={(value) => {
                                        console.log(value)
                                        this.setState({ project: value });
                                      }}
                                    >
                                      {this.state.projects.map(val => (
                                        <TreeNode value={val.id} title={this.props.isRTL ? val.name_ar : val.name_en} key={val.id} />
                                      ))}
                                    </TreeSelect>
                                  </MDBCol>
                                </MDBRow>

                                <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>

                                  <MDBCol md="6">
                                    <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.visitingDate}</label>
                                    <DatePicker
                                      dropdownAlign={{ points: ['bl', 'tl'] }}
                                      placement="topLeft"
                                      showTime={{ use12Hours: true, format: 'h:mm A' }}
                                      style={{
                                        width: '100%',
                                        textAlign: this.props.isRTL ? 'right' : 'left',
                                        marginBottom: '1rem'
                                      }}
                                      onChange={(date, dateString) => {
                                        this.setState({ visitingDate: dateString });
                                      }}
                                      disabled={this.state.actionType === "VIEW"}
                                      defaultValue={
                                        this.state.visitingDate ? moment(this.state.visitingDate) : null
                                      }
                                      placeholder={
                                        this.state.visitingDate
                                          ? moment(this.state.visitingDate).format('MMMM Do YYYY, h:mm a')
                                          : allStrings.visitingDate
                                      }
                                    />
                                  </MDBCol>
                                  <MDBCol md="6"></MDBCol>
                                </MDBRow>
                                <MDBRow>
                                  <MDBCol md="12">
                                    <div class="md-form">
                                      <label htmlFor="form65" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.visitingReport}</label>
                                      <br></br>
                                      <div class="valid-feedback">{allStrings.correct}</div>
                                      <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                      <textarea disabled={this.state.actionType === "VIEW" ? true : false} style={{ border: 'none', borderBottom: '1px solid #dededede', direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} value={this.state.report} type="text" id="form645" name="report" class="form-control" required onChange={this.changeHandler} validate placeholder="أدخل التقرير..." />
                                    </div>
                                  </MDBCol>
                                </MDBRow>
                                {this.state.employee &&
                                  <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                                    <MDBCol md="10" xs="10">
                                      <div class="md-form">
                                        <label htmlFor="form80" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.employee}</label>
                                        <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.employee ? this.state.employee.fullname : ''} type="text" id="form80" class="form-control" />
                                        <div class="valid-feedback">{allStrings.correct}</div>
                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                      </div>
                                    </MDBCol>
                                    <MDBCol md="2" xs="2">
                                      <p style={{ textAlign: 'center', marginTop: '2rem', color: '#2BBBAD', pointerEvents: this.state.employee === null ? 'none' : 'auto' }}>
                                        <span style={{ cursor: 'pointer', position: 'absolute', padding: '3px' }} class="material-icons"
                                          onClick={() => { this.props.history.push('userInfo', { data: this.state.employee }) }}>
                                          remove_red_eye
                                        </span>
                                        <span style={{ cursor: 'pointer', fontSize: '16px', fontWeight: '500', marginLeft: '2rem' }}
                                          onClick={() => { this.props.history.push('userInfo', { data: this.state.employee }) }}>
                                          {allStrings.show}
                                        </span>
                                      </p>
                                    </MDBCol>
                                  </MDBRow>
                                }
                              </div>
                              <br></br>
                              <br></br>
                              <div className="text-center">
                                <div>

                                  {this.state.actionType == "EDIT" &&
                                    <MDBBtn
                                      type="submit" style={{ background: 'linear-gradient(135deg, #1D9598, #127275)' }}
                                      rounded
                                      className="btn-block z-depth-1a"
                                    >
                                      <MDBIcon icon="edit" className="mr-2" />
                                      {allStrings.update}
                                    </MDBBtn>
                                  }
                                </div>
                              </div>
                            </form>
                          </MDBCol>
                        </MDBRow>
                      </MDBContainer>
                    </CardContent>
                  </Card>
                </div>
              </MDBCol>
            </MDBRow>
          </MDBContainer>
        </Spin>
      </div>
    )
  }
}


const mapToStateProps = (state) => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
});

const mapDispatchToProps = {
};

export default withRouter(
  connect(mapToStateProps, mapDispatchToProps)(visitingInfo)
);
